var _path, _circle, _circle2, _circle3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmNewUserQueue = function SvgBmNewUserQueue(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.4,0H.6A.6.6,0,0,0,0,.6V13.2a.6.6,0,0,0,.6.6H17.4a.6.6,0,0,0,.6-.6V.6A.6.6,0,0,0,17.4,0ZM6.96,4.3a2.334,2.334,0,0,1,.84-.834,2.4,2.4,0,0,1,2.364,0,2.334,2.334,0,0,1,.876.834,2.19,2.19,0,0,1,0,2.292,2.4,2.4,0,0,1-4.08,0A2.19,2.19,0,0,1,6.96,4.3ZM13.2,11.04a.516.516,0,0,1-.528.51H5.328a.516.516,0,0,1-.528-.51v-.762a1.962,1.962,0,0,1,.276-1.026,2.016,2.016,0,0,1,.768-.738A2.118,2.118,0,0,1,6.9,8.238h.9a2.922,2.922,0,0,0,2.4,0h.9a2.118,2.118,0,0,1,1.056.276,2.016,2.016,0,0,1,.768.738,1.962,1.962,0,0,1,.276,1.026Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1.5 15)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(7.5 15)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(13.5 15)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmNewUserQueue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_NewUserQueue.f612a92a.svg";
export { ForwardRef as ReactComponent };